export var circleChart = {
    chart: {
        height: 250,
        type: 'radialBar',
    },
    colors: ['#52616B'],
    plotOptions: {
        radialBar: {
            hollow: {
                size: '70%',
            }
        },
    },
    series: [70],
    labels: ['Cricket'],
}